<template>
	<div class="wrapper">
		<div class="modal" :class="{ hide: !pageLoading }">
			<div id="main-spinner" class="page-spinner-wrapper main-spinner">
				<span class="spinner-circle"></span>
			</div>
		</div>

		<div v-if="!pageLoading" class="murk">
			<BalanceInfo :title="$t('checkout.title')" is-in-game />

			<completed v-if="resultType === 'complete'" />
			<insufficient v-else-if="resultType === 'insufficient'" />
			<pending v-else-if="resultType === 'pending'" />
			<failed v-else-if="resultType === 'failed'" :error-code="errorCode" :mileage-name="mileageName" />

			<!-- FE-2600 added a dummy iframe with redirectUrl src and displaying it when the displayCallbackIframe from localstorage is true (same is used for the back to the game button) per commerce team request in case users are closing the window browsers for in-game instead of clicking our button with redirectUrl  -->
			<iframe
				v-if="redirectUrl && this.$store.state.displayCallbackIframe"
				class="hidden-iframe"
				:src="redirectUrl"
			/>
		</div>
	</div>
</template>

<script>
import BalanceInfo from '@/components/common/balance-info';
import Completed from './completed';
import Failed from './failed';
import Pending from './pending';
import Insufficient from './insufficient';

export default {
	name: 'InGameOrder',
	components: {
		BalanceInfo,
		Completed,
		Insufficient,
		Pending,
		Failed,
	},
	data() {
		return {
			pageLoading: false,
			resultType: null,
			errorCode: null,
			mileageName: null,
		};
	},
	computed: {
		inGameTransactionResult() {
			return this.$store.state.inGameTransactionResult;
		},
		productPurchaseInfo() {
			return this.inGameTransactionResult.productPurchaseInfo;
		},
		payment() {
			return this.inGameTransactionResult.payment;
		},
		paymentBalanceUpdate() {
			return this.payment && this.payment.balanceUpdate;
		},
		paymentBalanceUpdatePurchase() {
			return this.paymentBalanceUpdate && this.paymentBalanceUpdate.purchase;
		},
		redirectUrl() {
			// return this.inGameTransactionResult.redirectUrl;
			// hotfix: 2025-05-09 [MSW][ARENA] 결제 후 WC 미지급 관련(GSTR-1492) 건으로 S to S 로 변경하여 해당부분 수정 진행
			return '';
		},
	},
	methods: {
		cancel() {
			if (this.redirectUrl) {
				window.location.replace(this.redirectUrl);
			} else {
				window.close();
			}
		},
	},

	beforeRouteEnter(to, from, next) {
		next(async (vm) => {
			vm.pageLoading = true;

			const status = to.query.status,
				error = to.query.error_code,
				result = to.query.result,
				checkoutId = to.query.checkoutId,
				mileageName = to.query.mileageName;

			if (status === 'complete') {
				// sufficient case, when user has sufficient amount and the payment is not required, user is coming directly from the /checkout/en/in-game/order after clicking complete purchase (completeInGameTransaction API)
				vm.resultType = status;

				dataLayer.push({
					event: 'In Game Purchase Complete',
					IGP_amount: vm.productPurchaseInfo ? vm.productPurchaseInfo.orderTotal : '',
					IGP_currency: vm.productPurchaseInfo ? vm.productPurchaseInfo.currency : '',
					IGP_sufficient: true,
				});
			} else if (checkoutId) {
				// if the url contains 'checkoutId' query then check the 'result' (might be success/cancel/failed) query and call proper API
				try {
					if (result === 'cancel') {
						// cancel transaction case (for the case when the BE will redirect to the result page with checkoutId and result=cancel query parameters)

						await vm.$checkoutAPI.getInGameTransactionTypeResult(checkoutId, result);
						return vm.cancel();
					} else if (result === 'failed') {
						// failed transaction case (for the case when the BE will redirect to the result page with checkoutId and result=failed query parameters)

						await vm.$checkoutAPI.getInGameTransactionTypeResult(checkoutId, result);
						vm.resultType = result;
					} else {
						// success result (for the case when the BE will redirect to the result page with checkoutId and result=success query parameters)

						await vm.$checkoutAPI.getInGameTransactionResult(checkoutId); // status property from the API response can be pending/complete/canceled/failed/insufficient
						vm.resultType = vm.inGameTransactionResult.status;

						if (vm.resultType === 'complete' || vm.resultType === 'insufficient') {
							let eventName,
								igpAmount = '',
								igpCurrency = '';

							if (vm.resultType === 'complete') eventName = 'In Game Purchase Complete';
							else eventName = 'In Game Purchase Incomplete More Needed';

							if (vm.paymentBalanceUpdatePurchase && (vm.region === 'global' || vm.region === 'tw')) {
								// selected pricepoint amount
								igpAmount = vm.paymentBalanceUpdatePurchase.amount;
								igpCurrency = vm.paymentBalanceUpdatePurchase.currency;
							} else if (vm.productPurchaseInfo) {
								igpAmount = vm.productPurchaseInfo.orderTotal;
								igpCurrency = vm.productPurchaseInfo.currency;
							}

							dataLayer.push({
								event: eventName,
								IGP_amount: igpAmount,
								IGP_currency: igpCurrency,
								IGP_sufficient: false,
								...(vm.payment && vm.payment.paymentMethod
									? { IGP_paymentGateway: vm.payment.paymentMethod }
									: {}),
							});
						} else if (vm.resultType === 'pending') {
							dataLayer.push({
								event: 'In Game Purchase Pending',
								IGP_sufficient: false,
								...(vm.payment && vm.payment.paymentMethod
									? { IGP_paymentGateway: vm.payment.paymentMethod }
									: {}),
							});
						} else if (vm.resultType === 'canceled') return vm.cancel();
					}
				} catch (error) {
					vm.errorCode = (error.response && error.response.data && error.response.data.code) || null;
					vm.resultType = 'failed';
					vm.mileageName = mileageName;
				}
			} else if (error || to.name === 'in-game-purchase-failed') {
				vm.errorCode = error ? error : null;
				vm.resultType = 'failed';
				vm.mileageName = mileageName;
			} else {
				vm.resultType = 'failed';
				vm.mileageName = mileageName;
			}
			vm.pageLoading = false;
		});
	},
};
</script>

<style lang="scss" scoped>
.hidden-iframe {
	display: none;
	width: 1px;
	height: 1px;
}
</style>
